import React, { useEffect } from 'react';
import { SearchBox } from './../../../common/sharedComponents/SearchBox';
import { ISelectedOption } from './../../../@types/searchBox';
import { useTranslation } from 'react-i18next';
import { handleOptionClickUtil } from './../../../common/sharedComponents/SearchBox/utils';
import { useSearchTemplate } from './../../../common/hooks/useSearchTemplate';

export function SearchBoxTemplate ({ callBackSelectedOptions, clearFilter }) {
  const { t } = useTranslation();
  const {
    searchBoxOptions,
    selectedOptions,
    searchText,
    setSelectedOptions,
    setSearchText,
    setSearchBoxOptions,
  } = useSearchTemplate();

  useEffect(() => {
    setSearchText('');
    setSearchBoxOptions([]);
    setSelectedOptions([]);
  }, [clearFilter]);

  function handleInputChange (value: string) {
    setSearchText(value);
  }

  function handleOptionClick (selected: ISelectedOption) {
    const selectedOption = handleOptionClickUtil(selected, selectedOptions);
    if (selectedOption.length > 0) {
      setSelectedOptions([...selectedOptions, ...selectedOption]);
      callBackSelectedOptions([...selectedOptions, ...selectedOption]);
    }
  }

  function clearSearch () {
    setSearchText('');
    setSelectedOptions([]);
    callBackSelectedOptions([]);
  }

  return (
    <SearchBox
      handleInputChange={handleInputChange}
      searchBoxOptions={searchBoxOptions}
      handleOptionClick={handleOptionClick}
      selectedOptions={selectedOptions}
      searchTextName={searchText}
      clearSearch={clearSearch}
      placeholderText={t(
        'COMMON.MY_AUDIT.GENERIC_FIELDS.START_TYPING_TO_SELECT'
      )}
      label={t('COMMON.MY_AUDIT.GENERIC_FIELDS.FIND_CHECKLIST')}
    />
  );
}
